import React, { useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useStyles } from './Avatar.styles';
import clsx from 'clsx';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_AVATAR_BACKGROUND,
  ERROR_AVATAR_BACKGROUND,
  GREEN_DARK_AVATAR_BACKGROUND,
  GREEN_LIGHT_AVATAR_BACKGROUND,
  PLAIN_TEXT,
  PRIMARY_AVATAR_BACKGROUND,
  WARNING_AVATAR_BACKGROUND,
} = COLORS;

type Props = {
  title?: string;
  style?: object;
  className?: string;
  uuid?: string;
};
const backgroundColors = [
  DARK_AVATAR_BACKGROUND,
  ERROR_AVATAR_BACKGROUND,
  GREEN_DARK_AVATAR_BACKGROUND,
  GREEN_LIGHT_AVATAR_BACKGROUND,
  PRIMARY_AVATAR_BACKGROUND,
  WARNING_AVATAR_BACKGROUND,
];

const Avatar: React.FC<Props> = ({ title = 'No Company', uuid, style, className }) => {
  const classes = useStyles();

  const firstChar = uuid ? uuid.charAt(uuid.length - 1) : title.charAt(0);

  const randomizeColors = useMemo(() => {
    const index = firstChar.charCodeAt(0) % backgroundColors.length;
    const item = backgroundColors[index];
    return item;
  }, [firstChar]);

  return (
    <Box
      className={clsx(classes.container, className)}
      style={{ background: !title || title !== 'No Company' ? randomizeColors : '', ...style }}
    >
      <Typography variant="h5" style={{ textTransform: 'uppercase', color: PLAIN_TEXT }}>
        {title.charAt(0)}
      </Typography>
    </Box>
  );
};

export default React.memo(Avatar, (prev, next) => prev.title === next.title);
